$ = require 'jquery'
CardCopyView = require 'views/card/card-copy-view'
CardLabelSelectView = require 'views/label/card-label-select-view'
CardMemberSelectView = require 'views/card/card-member-select-view'
CardMoveView = require 'views/card/card-move-view'
CardViewHelpers = require './card-view-helpers'
CardViewMixins = require './card-view-mixins'
DatePickerView = require 'views/card/date-picker-view'
Keyboard = require 'lib/keyboard'
Keys = require 'data/keys'
PopOver = require 'views/lib/pop-over'
StickerEditView = require 'views/stickers/sticker-edit-view'
UserInput = require 'views/internal/user-input'
Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'
templates = require 'views/internal/templates'
track = require 'debug/track'
mixin = require 'lib/mixin'

module.exports = mixin CardViewHelpers, class QuickCardEditorView extends View
  _.extend(@prototype, CardViewMixins)

  className: 'quick-card-editor'

  @open: (cardView) ->
    @close()

    $el = cardView.$el
    offset = $el.offset()

    opts =
      width: $el.width()
      left: offset.left
      top: offset.top

    @current = new QuickCardEditorView
      model: cardView.model
      modelCache: cardView.modelCache
    .render(opts)

  @close: ->
    @current?.closeEditor()
    @current = null

  initialize: ->
    @makeDebouncedMethods 'renderStickers', 'renderLabels'

    @listenTo @model,
      'change:labels': @renderLabelsDebounced
      'change:idLabels': @renderLabelsDebounced

    @listenTo @model.labelList, 'add remove reset change', =>
      @renderLabelsDebounced()

    @listenTo @model.memberList, 'add remove reset',
      @frameDebounce @renderMembers

    @listenTo @model.stickerList, 'add remove reset change sort', ->
      @renderStickersDebounced()

  events:
    'keydown .js-edit-card-title': 'quickCardEditKeydown'
    'click .js-save-edits': 'saveEdits'

    'click .js-stop': 'stopCard'

    'click .js-edit-labels': 'editLabels'
    'click .js-edit-members': 'editMembers'
    'click .js-move-card': 'moveCard'
    'click .js-copy-card': 'copyCard'
    'click .js-edit-due-date': 'editDueDate'
    'click .js-archive': 'archive'

    'click': 'checkCloseEditor'
    'click .js-close-editor': 'closeEditor'

  showCover: ->
    @model.getBoard().getPref('cardCovers') && @model.hasCover()

  showStickers: -> true

  shortcut: (key) ->

    switch key
      when Keys.Escape
        @checkCloseEditor()
        ["Esc - Close Quick Card Editor", "Quick Card Editor"]

      when Keys.Enter
        @save()
        ["Enter - Save Quick Card Edits", "Quick Card Editor"]

  render: (opts) ->
    data = @model.toJSON()
    data.labels = @model.getLabels()
    data.showCover = @showCover()
    data.hasStickers = @model.hasStickers()
    data.quickEdit = true
    data.members = []

    # gotta position this thing
    data.left = @cLeft = opts.left
    data.top = @cTop = opts.top
    data.width = @cWidth = opts.width
    # 160 is the width of the controls, which are absolutely positioned
    cRight = @cWidth + @cLeft + 160
    wHeight = $(window).height()
    wWidth = $(window).width()

    if cRight > wWidth
      data.leftButtons = true
      @_usingLeftButtons = true

    @$el.html(
      templates.fill(
        'quick_card_editor',
        data
        {}
      )
    )

    @renderStickers()
    .renderCover()
    .renderLabels()
    .renderBadges()
    .renderMembers()
    .checkShowCover()

    # view.remove() removes the editor from# the DOM, which happens every time
    # we close the editor, so this is okay.
    $('body').append @$el

    @calcHeight()

    @focusInput()

    UserInput.addHandler @,
      scope: 'quick_card_editor'
      modal: true

    @defer =>
      @$('.quick-card-editor-buttons').addClass('fade-in')

    @$('.js-edit-card-title').autosize()

    @

  calcHeight: ->
    wHeight = $(window).height()
    wWidth = $(window).width()

    # Might overflow the window height so lets make sure that doesn't happen.
    # This needs to happen here because it's in the DOM now and the
    # calculations will be right.
    cHeight = @$('.quick-card-editor-card').outerHeight()
    if @cTop + cHeight > wHeight
      top = wHeight - cHeight - 8
      @$('.quick-card-editor-card').css top: top

    $buttons = @$('.quick-card-editor-buttons')
    bHeight = $buttons.outerHeight()
    bOffset = $buttons.offset()

    if bHeight + bOffset.top > wHeight
      $buttons.css top: -36

    return

  renderStickers: ->
    # Don't re-render the stickers if we contain something that's in
    # the middle of an edit
    if @$('.sticker.moving, .sticker.rotating').length > 0
      return @

    $stickers = @$('.js-card-stickers').empty()
    subviews = (@subview(StickerEditView, sticker) for sticker in @model.stickerList.models)
    @appendSubviews(subviews, $stickers)

    @$('.list-card').toggleClass('is-stickered', @model.hasStickers())

    @

  checkShowCover: ->

    @$('.list-card')
    .toggleClass('is-covered', @showCover())
    .toggleClass('is-stickered', @model.hasStickers())

    @

  focusInput: ->
    @$('.js-edit-card-title').focus().select()

  showPopOver: (e, viewClass, trackStr, opts = {}) ->
    Util.stop(e)

    PopOver.toggle
      elem: $(e.target).closest('a')
      view: new viewClass _.extend({ @model, @modelCache }, opts)
      alignRight: @_usingLeftButtons

    track("Quick Card Editor", trackStr)
    return

  editLabels: (e) ->
    @showPopOver(e, CardLabelSelectView, "Open Label Edit")

  editMembers: (e) ->
    @showPopOver(e, CardMemberSelectView, "Open Member Edit")

  copyCard: (e) ->
    @showPopOver e, CardCopyView, "Open Copy Card",
      onCopy: @closeEditor.bind(@)

  editDueDate: (e) ->
    @showPopOver(e, DatePickerView, "Open Due Date Edit")

  moveCard: (e) ->
    onCommit = @closeEditor.bind(@)
    @showPopOver e, CardMoveView, "Open Move Card", { onCommit }

  archive: (e) ->
    Util.stop(e)

    @model.close()
    @closeEditor()

    track("Quick Card Editor", "Archive")
    return

  quickCardEditKeydown: (e) ->
    if Keyboard.getKey(e) == Keys.Enter
      @saveEdits(e)

  saveEdits: (e) ->
    Util.stop(e)

    val = @$('.js-edit-card-title').val().trim()

    if val == @model.get('name')
      @closeEditor()
    else if val != ""
      @model.update({ name: val })
      @closeEditor()
      track("Quick Card Editor", "Save Name")
    else
      @$('.js-edit-card-title').focus().select()

    return

  checkCloseEditor: (e) ->
    if PopOver.isVisible
      PopOver.hide()
    else if @$('.sticker.editing').length > 0
      @stopEditingStickers()
    else
      @closeEditor(e)
    return

  closeEditor: (e) ->
    @remove()
    PopOver.hide()
    track("Quick Card Editor", "Close")
    return

  stopEditingStickers: ->
    for sticker in _.clone(@model.stickerList.models)
      sticker.trigger('stopEditing')
    return

  stopCard: (e) ->
    Util.stopPropagation(e)
    PopOver.hide()
    return



// WEBPACK FOOTER //
// ./app/scripts/views/card/quick-card-editor-view.coffee